import { usePageTitle } from "hooks/usePageTitle";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Layout } from "../components/Layout";
import { QRCodeDisplay } from "../components/QRCodeDisplay";

export function QRCodeGenerator() {
  usePageTitle("QR Code Generator");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(true);

  // Get the URL to generate QR code for, or use current origin as fallback
  const targetUrl = searchParams.get("url") || window.location.origin;
  const returnUrl = searchParams.get("return") || "/";

  // Redirect to home if accessed in release environment
  useEffect(() => {
    // @ts-ignore - VITE env vars
    if (import.meta.env.VITE_ENV === "release") {
      navigate("/");
    }
  }, [navigate]);

  const handleClose = () => {
    setOpen(false);
    // Navigate back to the original URL
    navigate(returnUrl);
  };

  // Update the window location to include the target URL
  useEffect(() => {
    // Store the current URL for the QR code generation
    window.history.replaceState(
      {},
      document.title,
      `/qr-code?url=${encodeURIComponent(targetUrl)}&return=${encodeURIComponent(returnUrl)}`
    );
  }, [targetUrl, returnUrl]);

  return (
    <Layout>
      <QRCodeDisplay open={open} onClose={handleClose} targetUrl={targetUrl} />
    </Layout>
  );
}
